module.exports = __webpack_public_path__ + "assets/img/xi.0cc22756.png";